export default {
  getData(state) {
    return state.data;
  },
  getUsers(state) {
    return state.users;
  },
  getTotal(state) {
    return state.total;
  },
  getLimit(state) {
    return state.limit;
  },
};
